import { useContext } from 'react';
import { useAppSelector } from '../../../../store/redux/hooks';
import { MeContext } from '../../../../context/MeContext';
import { MeContextState } from '../../../../store/types/account';
import { EnhancedDesignType } from '../../../../store/types/template';
import { allowedDesignsForTemplateType } from '../utils/enhancedDesignEligibility';

type EnhancedDesignForTemplate = {
  allowedDesigns: EnhancedDesignType[];
  available: boolean;
  storedDesign: EnhancedDesignType | null;
  isLocked: (design: EnhancedDesignType) => boolean;
  missingNfcEntitlement: boolean;
  missingPassBinding: boolean;
  templateNfcEnabled: boolean;
};

export const useEnhancedDesignForTemplate = (): EnhancedDesignForTemplate => {
  const templateType = useAppSelector((s) => s.template.templateType);
  const storedDesign = useAppSelector(
    (s) => s.template.appleEnhancedDesign.type
  );
  const templateNfcEnabled = useAppSelector((s) => s.template.nfc.enabled);
  const meCtx = useContext(MeContext) as { state: MeContextState };

  const entity =
    meCtx.state.entities?.length === 1
      ? meCtx.state.entities[0]
      : meCtx.state.filterEntity;

  const allowedDesigns = allowedDesignsForTemplateType(templateType);
  const available = !!meCtx.state.appleEnhancedDesignEnabled;

  const missingNfcEntitlement = !entity?.appleNfcEnabled;
  const missingPassBinding = !meCtx.state.passBindingEnabled;

  const isLocked = (design: EnhancedDesignType) =>
    design === 'eventTicket' && missingNfcEntitlement;

  return {
    allowedDesigns,
    available,
    storedDesign,
    isLocked,
    missingNfcEntitlement,
    missingPassBinding,
    templateNfcEnabled,
  };
};
